import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2022.05.26
 *
 **/
const SearchApiService = {
    /**
     * 提现审核(2.0)
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=157#7060
     * @param data
     */
    updateApproved(data={}) {
        return request({
            url:  '/service/mg/distributor/withdraw-save',
            method: "POST",
            data
        });
    },
    /**
     * 推广详情头部(2.0)
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=157#7068
     * @param data
     */
    getDistributor(data={}) {
        return request({
            url:  '/service/mg/distributor/get',
            method: "POST",
            data
        });
    },
    /**
     * 查看分销商
     *  http://rap.essa.top:88/workspace/myWorkspace.do?projectId=157#4664
     * @param data
     */
    getDistributorInfo(data={}) {
        return request({
            url:  '/service/fenxiao/basic-info/queryDistributor',
            method: "POST",
            data
        });
    },
    /**
     *  重置密码
     *  http://rap.essa.top:88/workspace/myWorkspace.do?projectId=157#4659
     url:  '/service/fenxiao/basic-info/resetPassword',
     * @param data
     */
    resetPassword(data={}) {
        return request({
            url:'/service/fenxiao/buyer/update',
            method: "POST",
            data
        });
    },
    /***
     * /service/fenxiao/buyer/delete
     * */
    delete(data={}) {
        return request({
            url:'/service/fenxiao/buyer/delete',
            method: "POST",
            data
        });
    },

    bindBuyer(data) {//绑定客户
        return request({
          url: '/service/mg/distributor/bind-buyer',
          method: 'POST',
          data
        })
      }
};

export default SearchApiService;
